import moment from 'moment';

const mutationTypes = {
    UPDATE_AGE: 'UPDATE_AGE',
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET',
};

// Initial State
const state = {
    dateOfBirth: null,
    dateOfDeath: null,
    age: null,
};

// Getters
const getters = {
    value: state => key => state[key],
};

function roundYears(years) {
    return Math.round(years * 100) / 100;
}

// Actions
const actions = {
    calculateAge({ state, commit }) {
        const mDob = moment(state.dateOfBirth, 'DD/MM/YYYY');
        const mDod = moment(state.dateOfDeath, 'DD/MM/YYYY');
        if (mDob.isValid() && mDod.isValid()) {
            const age = roundYears(mDod.diff(mDob, 'years', true));
            commit(mutationTypes.UPDATE_AGE, { age });
        }
    },
    update({ commit }, { key, value }) {
        commit(mutationTypes.UPDATE_VALUE, { key, value });
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_AGE](state, age) {
        state.age = age.age;
    },
    [mutationTypes.UPDATE_VALUE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET](state) {
        state.age = null;
        state.dateOfDeath = null;
        state.dateOfBirth = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/age.js